import React from 'react';

import { DASHBOARD_ITEM_API_NAMES } from '@src/constants/commons';

import DashboardWidget from '../DashboardWidget';
import { counterConfig, counterNumberComponentConfig } from '../DashboardWidget/configs';

const CounterCard = ({ chart, onEdit, refresh, filters }) => {
  const configs = {
    [DASHBOARD_ITEM_API_NAMES.EVENT_COUNTER_NUMBER_COMPONENT]: counterNumberComponentConfig,
  };
  return (
    <DashboardWidget
      widget={chart}
      onEdit={onEdit}
      refresh={refresh}
      filters={filters}
      config={configs[chart.apiName] || counterConfig}
    />
  );
};

export default CounterCard;
